import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Button } from '../../../../components';
import {
    ClockIcon,
    IconCheckmark,
    IconCalendar,
    MapMarkerIcon,
    IconWeight,
    IconFlash,
    IconPersonSafetyL,
    IconRadius,
    IconThumbUp,
    IconWalking,
    IconRuler,
    IconEducation,
    IconChart,
    IconPencilLetterL,
    IconCertificate,
} from '../../../../icons';
import css from './SectionMatchingCriteria.css';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

const SectionMatchingCriteria = ({ history }) => (
    <section className={css.root}>
        <header id="kriterien">
            <h2 className={css.subHeading}>Matching-Kriterien</h2>
            <p className={css.heading}>Das sind die Matching-Kriterien</p>
            <p className={css.description}>
                {`Unser Algorithmus kann anhand verschiedener Kriterien die Übereinstimmung berechnen. \nDazu verwenden wir uns auf die Daten aus deinem Profil oder Inserat.`}
            </p>
        </header>

        <main className={css.content}>
            <div className={css.criteriaBlock}>
                <h3>Diese Kriterien werden berücksichtigt</h3>
                <div className={css.criteriaItemHolder}>
                    <div className={css.criteriaItem}>
                        <MapMarkerIcon />
                        <p>Standort</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconRadius />
                        <p>Radius</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconWalking />
                        <p>Mobilität</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <ClockIcon />
                        <p>Verfügbarkeit</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconCalendar />
                        <p>Alter</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconCheckmark />
                        <p>Interessen</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconFlash />
                        <p>Disziplinen</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconChart />
                        <p>Niveau</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconPersonSafetyL />
                        <p>Qualifikationen</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconThumbUp />
                        <p>Besondere Skills</p>
                    </div>
                </div>
            </div>
            <div className={css.criteriaBlock}>
                <h3>Diese Kriterien werden nicht berücksichtigt</h3>
                <div className={css.criteriaItemHolder}>
                    <div className={css.criteriaItem}>
                        <IconPencilLetterL />
                        <p>Beschreibung</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconRuler />
                        <p>Grösse</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconWeight />
                        <p>Gewicht</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconThumbUp />
                        <p>Empfehlungen</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconCertificate />
                        <p>Auszeichnungen</p>
                    </div>
                    <div className={css.criteriaItem}>
                        <IconEducation />
                        <p>Ausbildungen</p>
                    </div>
                </div>
            </div>
        </main>

        <footer className={css.footer}>
            <Button
                className={css.subLinkPrimary}
                type="button"
                onClick={() =>
                    history.push(createResourceLocatorString('SignupPage', routeConfiguration()))
                }
            >
                Kostenlos registrieren
            </Button>
        </footer>
    </section>
);

export default compose(withRouter)(SectionMatchingCriteria);
